import React, { useState, useEffect } from 'react';

const IndiaPopup = ({ isVisible, onClose }) => {
	const [countdown, setCountdown] = useState(10);
	const [isCountdownActive, setIsCountdownActive] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setCountdown(10);
			setIsCountdownActive(true);

			const timer = setInterval(() => {
				setCountdown((prev) => {
					if (prev <= 1) {
						clearInterval(timer);
						// Auto redirect to India site
						handleVisitIndia();
						return 0;
					}
					return prev - 1;
				});
			}, 1000);

			return () => clearInterval(timer);
		}
	}, [isVisible]);

	const handleVisitIndia = () => {
		let queryParams = window.location.search;
		queryParams += (queryParams ? '&' : '?') + 'aud_p=redirected';

		const indiaUrl = `https://hear.com/in${queryParams}`;
		window.location.href = indiaUrl;
	};

	const handleContinueOnSite = () => {
		onClose();
	};

	if (!isVisible) return null;

	const handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			handleContinueOnSite();
		}
	};

		return (
		<div 
			className="c-country-popup-overlay"
			onKeyDown={handleKeyDown}
			tabIndex={0}
			role="dialog"
			aria-label="Country selection popup overlay"
		>
			<div
				className="c-country-popup c-india-popup-new"
				onClick={(e) => e.stopPropagation()}
				onKeyDown={(e) => e.stopPropagation()}
				tabIndex={0}
				role="dialog"
				aria-label="Country selection popup"
				style={{ 
					position: 'relative',
					overflow: 'visible'
				}}
			>
				<button 
					className="c-popup-close-btn" 
					onClick={handleContinueOnSite} 
					aria-label="Close popup"
				>
					<img 
						src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/close-button.svg"
						alt="Close"
					/>
				</button>

				<div className="c-popup-content">
					<div className="c-popup-header">
					<div className="o-row-1">
						<p className="c-popup-header__title">
							Welcome to <span className="u-color-brand">hear.com</span>
						</p>
						</div>
						<div className="o-row-2">
							<p className="c-popup-header__subtitle">It looks like you're visiting from India.</p>
						</div>
					</div>
					<div className="o-row-2">
						<img
							src="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,fl_lossy,q_auto:eco,w_auto,dpr_auto/assets/na/seo-website/india-flag.png"
							alt=""
						/>
					</div>
					<div className="o-row-2">
						<p className="c-popup-description">Explore our India website for localized offers and services</p>
					</div>
					<div className="c-popup-actions">
						<button className="c-btn-primary-india" onClick={handleVisitIndia}>
							Yes, visit hear.com India{' '}
							<img
								src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/arrow-right.svg"
								alt=""
							/>
						</button>
						<button className="c-btn-secondary-india" onClick={handleContinueOnSite}>
							<img
								src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/globe.svg"
								alt=""
							/>
							No, continue on this site
						</button>
					</div>

					<div className="c-india-skyline">
						<img
							className="o-fluid-img"
							src="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,fl_lossy,q_auto:eco,w_auto,dpr_auto/assets/na/seo-website/india-skyline.png"
							alt=""
						/>
					</div>

					{isCountdownActive && (
						<div className="c-countdown-banner">You will be redirected in {countdown} seconds if no action is taken.</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default IndiaPopup;
